<template>
  <div class="onls-checkbox">
    <div v-if="label" class="field-label">{{ label }}</div>

    <div class="onls-checkbox__wrapper">
      <label
          v-for="(item, i) in options"
          :key="i"
          class="onls-checkbox__label"
      >
        <input
            type="checkbox"
            :checked="value.includes(reduce ? item[reduce] : item)"
            @input="onInput(item)"
        />
        <div class="onls-checkbox__checkmark">
          <checkmark-icon :class="['onls-checkbox__checkmark-icon', { 'onls-checkbox__checkmark-icon--checked': value.includes(reduce ? item[reduce] : item) }]" />
        </div>
        <span class="onls-checkbox__text">{{ item[placeholder] }}</span>
      </label>
    </div>

    <onls-field-error :error-message="errorMessage"/>
  </div>
</template>

<script setup lang="ts">
import { type PropType } from 'vue';
import { OnlsFieldError, CheckmarkIcon } from '../index';

const props = defineProps({
  reduce: { type: String, default: 'id' },
  placeholder: { type: String, default: 'title' },
  options: { type: Array as PropType<Array<Record<string, any>>>, required: true },
  label: { type: String, default: "" },
  value: { type: Array, default: () => ([]) },
  errorMessage: { type: String },
});

const emits = defineEmits(['update:value']);

const onInput = (item: Record<string, any>) => {
  if (!props.value!.includes(props.reduce ? item[props.reduce] : item)) {
    emits('update:value', [...props.value, item[props.reduce]]);

    return;
  }

  emits('update:value', props.value!.filter((checkedItem: any) => checkedItem !== item[props.reduce]));
};
</script>

<style lang="scss">
.onls-checkbox {
  &__wrapper {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 30px;
  }

  &__label {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 20px;
    text-transform: uppercase;
    color: var(--primary-text);
  }

  input[type="checkbox"] {
    display: none;
  }

  &__text {
    font-size: 20px;
    color: var(--primary-text);
  }

  &__checkmark {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border: 2px solid var(--primary-text);
    border-radius: 5px;
    margin-right: 10px;

    &-icon {
      display: none;
      position: relative;

      &--checked {
        display: block;
      }
    }
  }

  @media screen and (max-width: 768px) {
    &__checkmark {
      width: 20px;
      height: 20px;

      &-icon {
        height: 7px !important;
      }
    }

    &__text {
      font-size: 12px;
    }
  }
}
</style>
